let cachedDeviceInfo = null;

function safeNavigator() {
  return typeof navigator !== 'undefined' ? navigator : null;
}

function safeWindow() {
  return typeof window !== 'undefined' ? window : null;
}

function getOsDetails(ua) {
  if (!ua) return { os: null, system_version: null };

  const lower = ua.toLowerCase();

  if (lower.includes('iphone') || lower.includes('ipad') || lower.includes('ipod')) {
    const match = ua.match(/OS ([\d_]+)/i);
    return { os: 'iOS', system_version: match ? match[1].replace(/_/g, '.') : null };
  }

  if (lower.includes('android')) {
    const match = ua.match(/Android ([\d.]+)/i);
    return { os: 'Android', system_version: match ? match[1] : null };
  }

  if (lower.includes('windows')) {
    const match = ua.match(/Windows NT ([\d.]+)/i);
    return { os: 'Windows', system_version: match ? match[1] : null };
  }

  if (lower.includes('mac os x')) {
    const match = ua.match(/Mac OS X ([\d_]+)/i);
    return { os: 'macOS', system_version: match ? match[1].replace(/_/g, '.') : null };
  }

  return { os: null, system_version: null };
}

function parseBrowser(nav, ua) {
  const brands =
    nav && nav.userAgentData && Array.isArray(nav.userAgentData.brands)
      ? nav.userAgentData.brands
      : [];

  const primaryBrand = brands
    .filter(b => b && b.brand && b.brand !== 'Not/A Brand')
    .sort((a, b) => Number(b.version || 0) - Number(a.version || 0))[0];

  const engine = (nav && typeof nav.product === 'string') ? nav.product : null;

  if (primaryBrand && primaryBrand.brand) {
    return {
      name: primaryBrand.brand,
      version: primaryBrand.version || null,
      engine
    };
  }

  if (!ua) return { name: null, version: null, engine };

  let m =
    ua.match(/(Firefox|FxiOS)\/([\d.]+)/i) ||
    ua.match(/(Edg|Edge|EdgiOS)\/([\d.]+)/i) ||
    ua.match(/(OPR|Opera)\/([\d.]+)/i) ||
    ua.match(/(Chrome|CriOS)\/([\d.]+)/i);

  if (m) return { name: m[1], version: m[2] || null, engine };

  m = ua.match(/Version\/([\d.]+).*Safari/i);
  if (m) return { name: 'Safari', version: m[1] || null, engine };

  m = ua.match(/Safari\/([\d.]+)/i);
  if (m) return { name: 'Safari', version: m[1] || null, engine };

  return { name: null, version: null, engine };
}

function safeTimeZone() {
  try {
    if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) return null;
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (e) {
    return null;
  }
}


function normalizeStringMap(obj) {
  const out = {};
  for (const key of Object.keys(obj)) {
    const value = obj[key];
    if (value === undefined || value === null) continue;

    const str = String(value).trim();
    if (!str) continue;

    out[key] = str;
  }
  return out;
}

export function getDeviceInfo() {
  if (cachedDeviceInfo) return cachedDeviceInfo;

  const nav = safeNavigator();
  const win = safeWindow();

  const ua = (nav && typeof nav.userAgent === 'string') ? nav.userAgent : '';
  const osDetails = getOsDetails(ua);
  const browser = parseBrowser(nav, ua);
  const timeZone = safeTimeZone();

  const rawDeviceInfo = {
    device_name:
      (nav && nav.userAgentData && nav.userAgentData.platform) ||
      (nav && nav.platform) ||
      'web',

    device_model:
      (nav && nav.userAgentData && nav.userAgentData.model) ||
      ua ||
      'web',

    os: osDetails.os,
    system_version: osDetails.system_version,

    browser_name: browser.name,
    browser_version: browser.version,
    engine: browser.engine,

    screen_width: win && win.screen ? win.screen.width : null,
    screen_height: win && win.screen ? win.screen.height : null,
    viewport_width: win ? win.innerWidth : null,
    viewport_height: win ? win.innerHeight : null,

    timezone: timeZone,
    user_agent: ua
  };

  const normalized = normalizeStringMap(rawDeviceInfo);

  cachedDeviceInfo = Object.freeze(normalized);
  return cachedDeviceInfo;
}
